var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTranslation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 5.875H22.625V11H25V4.5C25 3.94687 24.5531 3.5 24 3.5H3C2.44687 3.5 2 3.94687 2 4.5V27.5C2 28.0531 2.44687 28.5 3 28.5H20V26.125H4.375V5.875Z",
    fill: "#181818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9467 8H11.0529C10.9467 8 10.8529 8.06875 10.8154 8.16875L6.84355 19.6688C6.83418 19.6938 6.83105 19.7219 6.83105 19.75C6.83105 19.8875 6.94355 20 7.08105 20H8.80293C8.90918 20 9.00293 19.9312 9.04043 19.8312L10.0623 16.875H16.1936L13.1873 8.16875C13.1467 8.06875 13.0529 8 12.9467 8ZM13.3342 15.125H10.6623L11.9998 11.2563L13.3342 15.125ZM29.2498 16.5H24.9998V13.5938C24.9998 13.4563 24.8873 13.3438 24.7498 13.3438H22.9998C22.8623 13.3438 22.7498 13.4563 22.7498 13.5938V16.5H18.4998C18.0842 16.5 17.7498 16.8344 17.7498 17.25V22.75C17.7498 23.1656 18.0842 23.5 18.4998 23.5H22.7498V28.25C22.7498 28.3875 22.8623 28.5 22.9998 28.5H24.7498C24.8873 28.5 24.9998 28.3875 24.9998 28.25V23.5H29.2498C29.6654 23.5 29.9998 23.1656 29.9998 22.75V17.25C29.9998 16.8344 29.6654 16.5 29.2498 16.5ZM22.7498 21.25H19.9998V18.75H22.7498V21.25ZM27.7498 21.25H24.9998V18.75H27.7498V21.25Z",
    fill: "#181818"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTranslation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Translation.565a90c0.svg";
export { ForwardRef as ReactComponent };